import { render, staticRenderFns } from "./L05Box3DMaterialCapture.vue?vue&type=template&id=6cc04792&"
import script from "./L05Box3DMaterialCapture.vue?vue&type=script&lang=js&"
export * from "./L05Box3DMaterialCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports